module.exports = __webpack_public_path__ + "media/components/stylesheets/BrandonText-RegularItalic-f2b129c544fb0f4c1fdc1eb8371a7fe6.woff2";